import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const VideocamOffIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="video-recorder-off" {...props} />;
};
